import { CustomerReportCard } from './components/CustomerReportCard';
import { CustomersSubtotalsReportCard } from './components/CustomersSubtotalsReportCard';

export const ReportsScreen = () => {
  return (
    <div className="width-100 flex-center-center-column-nowrap">
      <div className="page">
        <div className="flex-center-center-row-wrap gap-10">
          <CustomersSubtotalsReportCard />
          <CustomerReportCard />
        </div>
      </div>
    </div>
  );
};
